import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(
    private http: HttpClient,
    private _cookieService: CookieService
  ) {}

  personnalSpace: any = [
    {
      properties: '/api/secure/my-properties/',
    },
    {
      favorites: '/api/secure/my-favorites/',
    },
    {
      project: '/api/secure/my-project/',
    },
    {
      offers: '/api/secure/my-offers/',
    },
    {
      mandats: '/api/secure/my-mandats/',
    },
    {
      alertes: '/api/secure/my-alertes/',
    },
    {
      search: '/api/search/list',
    },
    {
      tutorials: '/api/secure/video/tutorial/liste/',
    },
  ];

  /**
   * getHeaders
   *
   * build our header for more security
   *
   * We send our token via this header
   *
   * @param isPostRequest {boolean}, type of the request
   */
  public getHeaders(isPostRequest: boolean): any {
    let userToken = this._cookieService.get('x-wsse');
    if (userToken === undefined) {
      let json = this._cookieService.get('user_token');
      if (json !== undefined) {
        userToken = JSON.parse(json).user_token;
      }
    }
    if (userToken !== undefined) {
      return new HttpHeaders({
        'x-wsse': userToken,
      });
    } else {
      return {};
    }
  }

  getDataDashboard(urlProperty: string, limit?: string) {
    let optionalParams: any = {};
    optionalParams['headers'] = this.getHeaders(false);

    limit = limit ? limit : '';
    let urlToFetch = this.personnalSpace.find((x: any) => {
      return Object.keys(x)[0] === urlProperty;
    });
    urlToFetch = Object.values(urlToFetch)[0];

    // url
    return this.http.get<any>(
      `${environment.apiUrl}` + urlToFetch + limit,
      optionalParams
    );
  }

  updateUser(paramsRequest: any) {
    let optionalParams: any = {};
    optionalParams['headers'] = this.getHeaders(false);
    return this.http.put<any>(
      `${environment.apiUrl}` + `/api/secure/users/`,
      paramsRequest,
      optionalParams
    );
  }

  getSearchHistory(id: any) {
    let optionalParams: any = {};
    optionalParams['headers'] = this.getHeaders(false);
    return this.http.get<any>(
      `${environment.apiUrl}` + `/api/search/${id}`,
      optionalParams
    );
  }

  deleteSearchHistory(id: any) {
    let optionalParams: any = {};
    optionalParams['headers'] = this.getHeaders(false);
    return this.http.get<any>(
      `${environment.apiUrl}` + `/api/search/delete/${id}`,
      optionalParams
    );
  }

  saveSearchHistory(paramsRequest: any) {
    let optionalParams: any = {};
    optionalParams['headers'] = this.getHeaders(false);
    return this.http.put<any>(
      `${environment.apiUrl}` + `/api/search`,
      paramsRequest,
      optionalParams
    );
  }

  getDocuments() {
    let optionalParams: any = {};
    optionalParams['headers'] = this.getHeaders(false);
    return this.http.get<any>(
      `${environment.apiUrl}` + `/api/secure/documents`,
      optionalParams
    );
  }

  downloadFile(type: any, id: any, token: any) {
    return `${environment.apiUrl}` + `/api/documents/${token}/${type}/${id}`;
  }

  uploadFile(paramsRequest: any) {
    let optionalParams: any = {};
    optionalParams['headers'] = this.getHeaders(false);
    return this.http.post<any>(
      `${environment.apiUrl}` + `/api/secure/documents`,
      paramsRequest,
      optionalParams
    );
  }

  downloadFileGUide(type: any, token: any) {
    return `${environment.apiUrl}` + `/api/guide_documents/${token}/${type}`;
  }

  mandatAmbassadorList(ambassador: any) {
    let optionalParams: any = {};
    optionalParams['headers'] = this.getHeaders(false);
    return this.http.get<any>(
      `${environment.apiUrl}` +
        `/api/secure/mandat/${ambassador}/ambassador/liste`,
      optionalParams
    );
  }

  agreeMandate(id: any, paramsRequest: any) {
    let optionalParams: any = {};
    optionalParams['headers'] = this.getHeaders(false);
    return this.http.post<any>(
      `${environment.apiUrl}` + `/api/biens/${id}/partner/`,
      paramsRequest,
      optionalParams
    );
  }

  customersAmbassadorList(ambassador: any) {
    let optionalParams: any = {};
    optionalParams['headers'] = this.getHeaders(false);
    return this.http.get<any>(
      `${environment.apiUrl}` +
        `/api/secure/customer/${ambassador}/ambassador/liste`,
      optionalParams
    );
  }

  amisAmbassadorList(ambassador: any) {
    let optionalParams: any = {};
    optionalParams['headers'] = this.getHeaders(false);
    return this.http.get<any>(
      `${environment.apiUrl}` +
        `/api/secure/ami/${ambassador}/ambassador/liste`,
      optionalParams
    );
  }

  createCustomer(paramsRequest: any) {
    let optionalParams: any = {};
    optionalParams['headers'] = this.getHeaders(false);
    return this.http.post<any>(
      `${environment.apiUrl}` + `/api/secure/customer/`,
      paramsRequest,
      optionalParams
    );
  }

  getVille(codeVille: any) {
    let optionalParams: any = {};
    optionalParams['headers'] = this.getHeaders(false);
    return this.http.get<any>(
      `${environment.apiUrl}` + `/api/codeville/${codeVille}`,
      optionalParams
    );
  }

  addFavoris(idFavoris: any) {
    let optionalParams: any = {};
    optionalParams['headers'] = this.getHeaders(false);
    return this.http.post<any>(
      `${environment.apiUrl}` + `/api/secure/my-favorites/` + idFavoris,
      {},
      optionalParams
    );
  }

  deleteFavoris(idFavoris: any) {
    let optionalParams: any = {};
    optionalParams['headers'] = this.getHeaders(false);
    return this.http.delete<any>(
      `${environment.apiUrl}` + `/api/secure/my-favorites/` + idFavoris,
      optionalParams
    );
  }

  cancelVisit(idVisite: any) {
    let optionalParams: any = {};
    optionalParams['headers'] = this.getHeaders(false);
    return this.http.delete<any>(
      `${environment.apiUrl}` + `/api/secure/my-visit/` + `${idVisite}`,
      optionalParams
    );
  }

  getAchatOffres(bienId: any) {
    let optionalParams: any = {};
    optionalParams['headers'] = this.getHeaders(false);
    return this.http.get<any>(
      `${environment.apiUrl}` + `/api/secure/offre-achat/${bienId}`,
      optionalParams
    );
  }

  setOfferResponse(offre: number, response: number) {
    let optionalParams: any = {};
    optionalParams['headers'] = this.getHeaders(false);
    return this.http.post<any>(
      `${environment.apiUrl}` +
        `/api/secure/offer/response/${offre}/${response}`,
      {},
      optionalParams
    );
  }

  getMesVisites(bienId: any) {
    let optionalParams: any = {};
    optionalParams['headers'] = this.getHeaders(false);
    return this.http.get<any>(
      `${environment.apiUrl}` +
        `/api/secure/property/${bienId}/schedule/?start=2015-01-01&end=2025-12-31&verbose=1`,
      optionalParams
    );
  }

  getQuestions(visiteId: any) {
    let optionalParams: any = {};
    optionalParams['headers'] = this.getHeaders(false);
    return this.http.get<any>(
      `${environment.apiUrl}` + `/api/visit-questions/${visiteId}`,
      optionalParams
    );
  }

  evalKeysitter(visiteId: any, data: any = {}) {
    let optionalParams: any = {};
    optionalParams['headers'] = this.getHeaders(false);
    return this.http.put<any>(
      `${environment.apiUrl}` + `/api/visits/${visiteId}/evaluation/`,
      data,
      optionalParams
    );
  }

  evalReports(visiteId: any, data: any = {}) {
    let optionalParams: any = {};
    optionalParams['headers'] = this.getHeaders(false);
    return this.http.put<any>(
      `${environment.apiUrl}` + `/api/visits/${visiteId}/reports/`,
      data,
      optionalParams
    );
  }

  deletAcoount() {
    let optionalParams: any = {};
    optionalParams['headers'] = this.getHeaders(false);
    return this.http.delete<any>(
      `${environment.apiUrl}` + `/api/secure/users/`,
      optionalParams
    );
  }

  askDelegation(bienId:number) {
    let optionalParams: any = {};
    optionalParams['headers'] = this.getHeaders(false);
    return this.http.post<any>(
      `${environment.apiUrl}` +
        `/api/biens/delegation/ask/${bienId}`,
      {},
      optionalParams
    );
  }
}
